module.exports = __webpack_public_path__ + "img/masukan_&_saran.9afa34f8.svg";